export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ evgSpuStatus, applicationStatus }) => {
      return !!(
        !['Q'].includes(evgSpuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ evgSpuStatus, applicationStatus }) => {
      return !!(
        !['Q'].includes(evgSpuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_applyFullMember') || '申请转正',
    icon: 'el-icon-circle-check',
    menuType: 'apply',
    allow: 'P',
    divided: true,
    disabled: ({ evgSpuStatus, applicationStatus }) => {
      return !!(
        !['Q'].includes(evgSpuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_full_member') || '转正产品',
    icon: 'el-icon-circle-check',
    menuType: 'fullMember',
    allow: 'F',
    divided: true,
    disabled: ({ evgSpuStatus }) => !['Q'].includes(evgSpuStatus),
  },
  {
    text: that.$l('btn_changeName') || '名称变更',
    icon: 'el-icon-edit-outline',
    menuType: 'changeName',
    allow: 'C',
    divided: true,
    disabled: ({ evgSpuStatus }) => !['Y'].includes(evgSpuStatus),
  },
  {
    text: that.$l('btn_add_sku') || '添加SKU',
    icon: 'el-icon-circle-plus-outline',
    menuType: 'addSku',
    allow: 'K',
    disabled: ({ evgSpuStatus }) => !['Y'].includes(evgSpuStatus),
  },
]
